import React, { useEffect, useState } from 'react';
import * as apcoaAPI from '@debbie/cortex/dist/api/bespoke/apcoa.js';
import * as filesAPI from '@debbie/cortex/dist/api/files.js';
import * as documentsAPI from '@debbie/cortex/dist/api/documents.js';
import { feeImageStreamParser, } from '@debbie/common/dist/bespoke/apcoa/index.js';
import { styled } from 'styled-components';
import Modal from '../../Modal.js';
import { c, notifications } from '@debbie/cortex/dist/index.js';
import Button from '../../Button.js';
import { DocumentTypes, RefIdTypes, } from '@debbie/common/dist/documents/index.js';
import { documentsEntity } from '@debbie/cortex/dist/documents/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import q from '@debbie/cortex/dist/query.js';
import { ArrowLeft, ArrowRight } from '../../Icons/index.js';
import ButtonGroup from '../../ButtonGroup.js';
import Loading from '../../Loading.js';
import Errors from '../../Errors.js';
const Images = (props) => {
    const { caseVoucher } = props;
    const [loadingImages, setLoadingImages] = useState(true);
    const [images, setImages] = useState(null);
    const [previewImageIndex, setPreviewImageIndex] = useState(null);
    const [error, setError] = useState(null);
    const loadImages = async () => {
        try {
            if (caseVoucher.referenceId) {
                let state = { state: 'initial' };
                const utf8Decoder = new TextDecoder('utf-8');
                const _images = await apcoaAPI.getFeeImagesStream(caseVoucher.referenceId);
                if (_images == null) {
                    setImages([]);
                    return;
                }
                const imageStream = _images.getReader();
                while (true) {
                    const res = await imageStream.read();
                    if (res.done) {
                        break;
                    }
                    const textContent = utf8Decoder.decode(res.value, { stream: true });
                    let str = textContent;
                    while (str != '') {
                        let [newState, newStr, obj] = feeImageStreamParser(state, str);
                        state = newState;
                        str = newStr;
                        if (obj != null) {
                            setImages((imgs) => (imgs == null ? [obj] : [...imgs, obj]));
                        }
                    }
                }
                setLoadingImages(false);
            }
        }
        catch (err) {
            setLoadingImages(false);
            setError('Error loading images');
        }
    };
    useEffect(() => {
        if (!images) {
            loadImages();
        }
    }, [caseVoucher.referenceId]);
    const previewImage = typeof previewImageIndex === 'number' && images
        ? images[previewImageIndex]
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, "Billeder"),
        React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', gap: '10px' } },
            images != null &&
                images.map((image, i) => caseVoucher.caseId ? (React.createElement(Image, { key: image.fileName, image: image, caseId: caseVoucher.caseId, setPreviewIndex: () => setPreviewImageIndex(i) })) : null),
            loadingImages && React.createElement(ImageLoader, null),
            error != null && React.createElement(Errors, { errors: [error] }),
            images != null && previewImage && caseVoucher.caseId && (React.createElement(Modal, { maxWidth: "1000px", onToggle: () => setPreviewImageIndex(null), header: previewImage.fileName },
                React.createElement("p", { style: { textAlign: 'center' } },
                    React.createElement(ButtonGroup, null,
                        React.createElement(Button, { theme: "secondary", onClick: () => {
                                const prev = (previewImageIndex || 0) - 1;
                                setPreviewImageIndex(prev < 0 ? images.length - 1 : prev);
                            } },
                            React.createElement(ArrowLeft, null)),
                        React.createElement(Button, { theme: "secondary", onClick: () => {
                                const next = (previewImageIndex || 0) + 1;
                                setPreviewImageIndex(next > images.length - 1 ? 0 : next);
                            } },
                            React.createElement(ArrowRight, null)))),
                React.createElement("img", { width: "100%", style: {
                        maxHeight: 'calc(100vh - 200px)',
                        maxWidth: '100%',
                        objectFit: 'contain',
                    }, src: `data:${previewImage.contentType};base64, ${previewImage.content}`, alt: `Billede: ${previewImage.fileName}` }),
                React.createElement("p", { style: { textAlign: 'center' } },
                    React.createElement(AddToDocumentation, { image: previewImage, caseId: caseVoucher.caseId, style: {} }),
                    ' ',
                    React.createElement(AddToNewInteraction, { image: previewImage, caseId: caseVoucher.caseId, style: {} })))))));
};
const Image = (props) => {
    const { image } = props;
    return (React.createElement(ImageContainer, { onClick: () => props.setPreviewIndex() },
        React.createElement(AddToDocumentation, { image: image, caseId: props.caseId }),
        React.createElement(AddToNewInteraction, { image: image, caseId: props.caseId }),
        React.createElement("img", { src: `data:${image.contentType};base64, ${image.content}`, alt: `Billede: ${image.fileName}` })));
};
const ImageLoader = () => {
    return (React.createElement(LoaderContainer, null,
        React.createElement(Loading, { width: "30px" })));
};
const LoaderContainer = styled.div `
  background: lightgray;
  border-radius: 5px;
  width: 264px;
  height: 264px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
const ImageContainer = styled.div `
  display: inline-block;
  position: relative;
  border-radius: 5px;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);

  width: 264px;
  height: 264px;

  button {
    opacity: 0;
  }

  &:hover {
    button {
      opacity: 1;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export default Images;
const AddToDocumentation = (props) => {
    const { image } = props;
    const [loadingAddToDocumentation, setLoadingAddToDocumentation] = useState(false);
    const [added, setAdded] = useState(false);
    const addToDocuments = async () => {
        try {
            setLoadingAddToDocumentation(true);
            const newFile = await filesAPI.save({
                content: image.content,
                name: image.fileName,
                contentType: image.contentType,
            });
            await documentsAPI.add(props.caseId, DocumentTypes.OTHER, RefIdTypes.CASE, newFile.file.fileId, false, undefined, undefined, 'debtor');
            notifications.notification({
                title: 'Billedet er tilføjet til dokumentation',
            });
            q.invalidate(keys.write.create(documentsEntity));
            setAdded(true);
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setLoadingAddToDocumentation(false);
    };
    return (React.createElement(Button, { style: props.style
            ? props.style
            : {
                position: 'absolute',
                bottom: '60px',
                left: '10px',
                right: '10px',
            }, size: "small", theme: "secondary", onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            addToDocuments();
        }, loading: loadingAddToDocumentation, disabled: added }, "Tilf\u00F8j til dokumentation"));
};
const AddToNewInteraction = (props) => {
    const { image } = props;
    const [added, setAdded] = useState(false);
    const [loadingAddToInteraction, setLoadingAddToInteraction] = useState(false);
    const addToNewInteraction = async () => {
        try {
            setLoadingAddToInteraction(true);
            const newFile = await filesAPI.save({
                content: image.content,
                name: image.fileName,
                contentType: image.contentType,
            });
            c.newInteractions.addFiles(props.caseId, [newFile.file]);
            notifications.notification({
                title: 'Billedet er tilføjet til interaktioner',
            });
            setAdded(true);
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setLoadingAddToInteraction(false);
    };
    return (React.createElement(Button, { style: props.style
            ? props.style
            : {
                position: 'absolute',
                bottom: '10px',
                left: '10px',
                right: '10px',
            }, size: "small", theme: "secondary", onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            addToNewInteraction();
        }, loading: loadingAddToInteraction, disabled: added }, "Tilf\u00F8j til interaktion (email, note...)"));
};
//# sourceMappingURL=FeeImages.js.map